import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const FYContext = createContext(null);
export const useFiscalYear = () => useContext(FYContext);

export function FiscalYearProvider({ children }) {
  const [years, setYears] = useState([]);
  const [fiscalYear, setFiscalYearState] = useState(
    () => Number(localStorage.getItem("wcc_fy")) || null
  );

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/fiscal-years");
      setYears(data);
      if (!fiscalYear && data.length) {
        const cur = data.find((y) => y.is_current) || data[0];
        setFiscalYearState(cur.year);
        localStorage.setItem("wcc_fy", cur.year);
      }
    } catch {}
  }, [fiscalYear]);

  useEffect(() => { load(); }, [load]);

  const setFiscalYear = (y) => {
    setFiscalYearState(Number(y));
    localStorage.setItem("wcc_fy", y);
  };

  return (
    <FYContext.Provider value={{ years, fiscalYear, setFiscalYear, reloadYears: load }}>
      {children}
    </FYContext.Provider>
  );
}
